//#region src/shared/strip-html.ts
const stripHtml = (html) => {
	if (!html) return html;
	let withoutTags;
	if (typeof DOMParser !== "undefined") try {
		const doc = new DOMParser().parseFromString(html, "text/html");
		withoutTags = doc.body ? doc.body.textContent || "" : "";
	} catch {
		withoutTags = html;
	}
	else withoutTags = html.replace(/<[^>]{0,2000}>/g, "").replace(/[<>]/g, "");
	return withoutTags.replace(/\s+/g, " ").trim();
};

//#endregion
export { stripHtml };